import { FandomPage } from "@/components/FandomPage";
import { IV, IV_PAIRS } from "@/components/villainessData";
import { IV_CHARM } from "@/components/charms";

const F = {
  id: "villainess", prefix: "iv", name: "Though I Am an Inept Villainess",
  heading: ["Butterflies, rats", "and beads."],
  intro: "Step into the Maiden Court, find your match, then wear their colors. Every character's bracelet can be made by hand just for you.",
  quizLabel: "Maiden Court · personality", quizLines: ["Who are you in", "the Maiden Court?"],
  quizIntro: "Answer seven questions to find your Inept Villainess match.",
  quiz: IV, pairs: IV_PAIRS, charm: IV_CHARM, cover: "/img/villainess-cover.jpg",
  bgColor: "#120804",
  bgImage: "radial-gradient(60% 50% at 85% 10%, rgba(251,146,60,0.22), transparent 70%), radial-gradient(45% 40% at 10% 85%, rgba(193,18,31,0.2), transparent 70%)",
  accent: {
    text: "text-orange-300", soft: "text-orange-200", border: "border-orange-200/25", bar: "bg-orange-400",
    hover: "hover:border-orange-300 hover:bg-orange-900/30", glow: "rgba(251,146,60,0.2)",
    panel: "bg-[#1f0f07]/85", answer: "border-orange-200/25 bg-[#120804]/60",
    card: "border-orange-200/20 bg-[#1f0f07]/85 hover:border-orange-200/50",
  },
};

export default function VillainessPage() {
  return <FandomPage f={F} />;
}
